var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderLogoSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.4 25h15.1c.4 0 .8-.1 1.1-.4s.4-.6.4-1.1v-9.9c0-.4-.1-.8-.4-1.1s-.6-.4-1.1-.4h-15.1c-.4 0-.8.1-1.1.4s-.4.6-.4 1.1v9.9c0 .4.1.8.4 1.1s.6.4 1.1.4zm-16.4 15c-.8 0-1.5-.3-2.1-.9s-.9-1.3-.9-2.1v-26c0-.8.3-1.5.9-2.1s1.3-.9 2.1-.9h34c.8 0 1.5.3 2.1.9s.9 1.3.9 2.1v26c0 .8-.3 1.5-.9 2.1s-1.3.9-2.1.9z",
    fill: "#5f6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderLogoSettings);
export default __webpack_public_path__ + "static/media/provider-logo-settings.2ce63e91401ee2a6e2c2d47ed482277e.svg";
export { ForwardRef as ReactComponent };